
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import scroll from 'vue-seamless-scroll'
import Vant from 'vant';
import 'vant/lib/index.css';

import "../node_modules/swiper/swiper.min.css"
import VueAwesomeSwiper from 'vue-awesome-swiper'
 
Vue.use(VueAwesomeSwiper)
Vue.use(Vant)
Vue.use(scroll)
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueCookie from 'vue-cookies'
Vue.use(VueCookie)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// app.js
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './config/rem'
Vue.config.productionTip = false

// Vue.use(ElementUI)

import './permission'

import '@/styles/index.scss' // 全局样式

import cxUI from './commonCXUI'
import './commonCXUI/theme-chalk/index.css'

Vue.use(cxUI,{zIndex: 500});

import tipModel from '@/components/tipModel';
Vue.component("tip-model",tipModel);

var _hmt = _hmt || [];
window._hmt = _hmt; // 将_hmt挂载到window下
 (function () {
       var hm = document.createElement("script");
      //  hm.src = "https://hm.baidu.com/hm.js?"+ 百度站点id;
       var s = document.getElementsByTagName("script")[0];
       s.parentNode.insertBefore(hm, s);
})();
  

new Vue({
  //  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
